export enum OrderState {
    Pending = 0, // Đặt hàng thành công
    Accepted = 1, // Đã xác nhận
    Rejected = 2, // Đã bị từ chối
    InProgress = 3, // đang chuẩn bị/ đang chế biến
    Available = 4, // đã chế biến xong; đã làm xong
    Canceled = 5, // đã hủy
    Delivering = 6, // đang mang cho khách/ khách đang đến lấy
    Delivered = 7, // đã giao cho khách
    Merged = 8, // bị gộp bàn
    PendingPayment = 9, // chờ thanh toán (khách yêu cầu tính tiền)
    Complete = 10, // hoàn thành
    DriverAllocated = 11, // Đã tìm thấy tài xế
    DriverArrived = 12, // Tài xế đã đến quán
    PaymentSuccess = 13,
    PaymentFailed = 14,
    Served = 15, // Đã phục vụ
    Custom = 99
}
